module.exports = __webpack_public_path__ + "static/media/Brightly_ios_4_preview.6f3a8cab.jpg";